import request from "@/plugin/request";

export const getConfig = () => request.post('/systemConfig/getPublicConfig')

// export const getPriceConfig = () => request.post('/systemConfig/getPrice')